// D-95 candidate responses: reject partial data before an account action is enabled.
const record = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
const id = (v) => typeof v === "string" && /^[a-f0-9]{24}$/.test(v);

export const deletionCapabilities = (d) => record(d) && d.version === 1 && d.deletion_request === true && d.immediate_deletion === false;

export function deletionImpact(d) {
  const value = record(d) && d.impact;
  if (!record(value) || !Array.isArray(value.circle_responsibilities) ||
      !Number.isSafeInteger(value.hosted_activities) || value.hosted_activities < 0) return null;
  const circles = value.circle_responsibilities;
  if (circles.some((c) => !record(c) || !record(c.group) || !id(c.group.id) ||
      typeof c.group.name !== "string" || !c.group.name.trim()) ||
      new Set(circles.map((c) => c.group.id)).size !== circles.length) return null;
  return { circles: circles.map((c) => c.group.name.trim()), hosted: value.hosted_activities };
}

export function deletionRequest(d) {
  if (!record(d) || !Object.prototype.hasOwnProperty.call(d, "request")) return null;
  if (d.request === null) return { request: null };
  const r = d.request;
  return record(r) && id(r.id) && r.status === "eingegangen" ? { request: { id: r.id, status: r.status } } : null;
}
